export type Mode = 'main' | 'embed' | 'upload';

export interface RuntimeEnv {
  readonly mode: Mode;
  readonly crossOriginIsolated: boolean;
  readonly userAgent: string;
}

export function readRuntimeEnv(mode: Mode): RuntimeEnv {
  return {
    mode,
    crossOriginIsolated:
      typeof globalThis.crossOriginIsolated === 'boolean' ? globalThis.crossOriginIsolated : false,
    userAgent: typeof navigator !== 'undefined' ? navigator.userAgent : 'unknown',
  };
}

export function isCrossOriginIsolated(): boolean {
  return typeof globalThis.crossOriginIsolated === 'boolean'
    ? globalThis.crossOriginIsolated
    : false;
}
